export const LOAD_LOYALTY_DATA = 'LOAD_LOYALTY_DATA';
export const LOYALTY_DATA_LOADING = 'LOYALTY_DATA_LOADING';

const init = {
  currentPoints: 0,
  currentStatus: null,
  programDescription: '',
  programTitle: '',
  statusTiers: [],
  nextStatus: null,
  completedActions: [],
  uncompletedActions: [],
  loading: false
};

export default function reducer(state = init, action = {}) {
  switch (action.type) {
    case LOAD_LOYALTY_DATA:
      return { ...state, ...action.data, loading: false };
    case LOYALTY_DATA_LOADING:
      return { ...state, loading: true };
    default:
      return state;
  }
}

export function formatLoyaltyData({
  current_status,
  loyalty_actions,
  points,
  title,
  description,
  status_tiers
}) {
  const statusTiers = (status_tiers || []).sort(
    (a, b) => a.point_value - b.point_value
  );
  const nextStatus = statusTiers.find(tier => tier.point_value > points);

  const incentives = (loyalty_actions || []).sort(
    (a, b) => b.points - a.points
  );
  const completedActions = incentives.filter(i => i.completed);
  const uncompletedActions = incentives.filter(i => !i.completed);
  const performableActions = incentives.filter(
    i => i.active && (!i.completed || i.repeatable)
  );

  return {
    currentPoints: points || 0,
    currentStatus: current_status || null,
    programTitle: title || '',
    programDescription: description || '',
    statusTiers,
    nextStatus: nextStatus || null,
    completedActions,
    uncompletedActions,
    performableActions
  };
}
